module.exports = __webpack_public_path__ + "/img/Chip-Labeled-pjJowm.svg";